import React, {Component} from "react"
import {
  buildChartOptions,
  CHART_MAX_HEIGHT,
  chartConfigBuilder, COLOR_LIST,
  DEFAULT_CHART_LABELS_CONFIG
} from "../../../../constants"
import {Line} from "react-chartjs-2"
import {ma} from "moving-averages"
import {injectIntl} from "react-intl"

const MAX_NUM_X_LABEL = 50

const getData = (dataStr, label, movingAvgSize = 0, format) => {

  const map = new Map()

  dataStr.split(/\|/).forEach(line => {
    const array = line.split(',')
    map.set(_.parseInt(array[0]), _.toNumber(array[1]))
  })

  const keys = _.sortBy(Array.from(map.keys()))

  // const m = _.max([2, _.ceil(keys.length / MAX_NUM_X_LABEL)])
  const m = 60

  const showLabel = (index)=>{
    const result = index%m === 0
    return result
  }

  const labels = keys.map((k, index)=>(showLabel(index)?k:''))
  const rawData = keys.map(k=>map.get(k))
  const result = {
    labels: labels,
    datasets: []
  }
  if(movingAvgSize > 0) {
    result.datasets.push({
      label: format({id:'moving.average'}),
      ...chartConfigBuilder(COLOR_LIST[2], 0, 1),
      data:_.concat(_.concat(_.fill(Array(movingAvgSize-1), null), ma(rawData, movingAvgSize))).map(it=>_.round(it)),
      pointRadius: 0,
    })
  }

  result.datasets.push({
    label: label,
    ...chartConfigBuilder(COLOR_LIST[0], 0, 1),
    data: rawData.map(it=>_.round(it)),
    pointRadius: 0,

  })
  return result

}

class CogolandActivityLineChart extends Component {
  render() {

    const format = this.props.intl.formatMessage

    const label = this.props.label || ''
    const data = getData(this.props.dataStr || '', label, this.props.movingAvgSize, format)

    const options = buildChartOptions({

      legend: {
        display: true,
      },
    }, data)

    options.scales.xAxes = [{
      gridLines: {
        display: false
      },
      scaleLabel:{
        display: true,
        labelString: format({id:'chart.time.sec'})
      },
      ticks:{
        beginAtZero: true,
        stepSize: 60,
        autoSkip: false,
        maxRotation: 0
      }
    }]

    options.scales.yAxes = [{
      gridLines: {
        display: true
      },
      ticks: {
        beginAtZero: true,
        stepSize: this.props.step || 50,
        suggestedMax: this.props.suggestedMax || 50,
        // min: 0,
        // max: 100
      }
    }]

    return (
      <div>
        <Line height={CHART_MAX_HEIGHT}
              data={data} options={options}/>
      </div>
    )
  }
}

export default injectIntl(CogolandActivityLineChart)



// WEBPACK FOOTER //
// ./src/routes/enterprise/dashboard/components/CogolandActivityLineChart.js